/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SelectOrgRouteImport } from './routes/select-org'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as AuthedDeviceRouteImport } from './routes/_authed/device'
import { Route as AuthedSitesIndexRouteImport } from './routes/_authed/sites/index'
import { Route as AuthedSettingsBillingRouteImport } from './routes/_authed/settings/billing'
import { Route as AuthedSitesSiteIdRouteRouteImport } from './routes/_authed/sites/$siteId/route'
import { Route as AuthedSitesSiteIdIndexRouteImport } from './routes/_authed/sites/$siteId/index'

const SelectOrgRoute = SelectOrgRouteImport.update({
  id: '/select-org',
  path: '/select-org',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDeviceRoute = AuthedDeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSitesIndexRoute = AuthedSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSettingsBillingRoute = AuthedSettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSitesSiteIdRouteRoute = AuthedSitesSiteIdRouteRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSitesSiteIdIndexRoute = AuthedSitesSiteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSitesSiteIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/select-org': typeof SelectOrgRoute
  '/device': typeof AuthedDeviceRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/sites/$siteId': typeof AuthedSitesSiteIdRouteRouteWithChildren
  '/settings/billing': typeof AuthedSettingsBillingRoute
  '/sites/': typeof AuthedSitesIndexRoute
  '/sites/$siteId/': typeof AuthedSitesSiteIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/select-org': typeof SelectOrgRoute
  '/device': typeof AuthedDeviceRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/settings/billing': typeof AuthedSettingsBillingRoute
  '/sites': typeof AuthedSitesIndexRoute
  '/sites/$siteId': typeof AuthedSitesSiteIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/select-org': typeof SelectOrgRoute
  '/_authed/device': typeof AuthedDeviceRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/_authed/sites/$siteId': typeof AuthedSitesSiteIdRouteRouteWithChildren
  '/_authed/settings/billing': typeof AuthedSettingsBillingRoute
  '/_authed/sites/': typeof AuthedSitesIndexRoute
  '/_authed/sites/$siteId/': typeof AuthedSitesSiteIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/select-org'
    | '/device'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/sites/$siteId'
    | '/settings/billing'
    | '/sites/'
    | '/sites/$siteId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/select-org'
    | '/device'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/settings/billing'
    | '/sites'
    | '/sites/$siteId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/onboarding'
    | '/select-org'
    | '/_authed/device'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/_authed/sites/$siteId'
    | '/_authed/settings/billing'
    | '/_authed/sites/'
    | '/_authed/sites/$siteId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  SelectOrgRoute: typeof SelectOrgRoute
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpSplatRoute: typeof SignUpSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/select-org': {
      id: '/select-org'
      path: '/select-org'
      fullPath: '/select-org'
      preLoaderRoute: typeof SelectOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up/$': {
      id: '/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof SignUpSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/device': {
      id: '/_authed/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof AuthedDeviceRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/sites/': {
      id: '/_authed/sites/'
      path: '/sites'
      fullPath: '/sites/'
      preLoaderRoute: typeof AuthedSitesIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/settings/billing': {
      id: '/_authed/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthedSettingsBillingRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/sites/$siteId': {
      id: '/_authed/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AuthedSitesSiteIdRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/sites/$siteId/': {
      id: '/_authed/sites/$siteId/'
      path: '/'
      fullPath: '/sites/$siteId/'
      preLoaderRoute: typeof AuthedSitesSiteIdIndexRouteImport
      parentRoute: typeof AuthedSitesSiteIdRouteRoute
    }
  }
}

interface AuthedSitesSiteIdRouteRouteChildren {
  AuthedSitesSiteIdIndexRoute: typeof AuthedSitesSiteIdIndexRoute
}

const AuthedSitesSiteIdRouteRouteChildren: AuthedSitesSiteIdRouteRouteChildren =
  {
    AuthedSitesSiteIdIndexRoute: AuthedSitesSiteIdIndexRoute,
  }

const AuthedSitesSiteIdRouteRouteWithChildren =
  AuthedSitesSiteIdRouteRoute._addFileChildren(
    AuthedSitesSiteIdRouteRouteChildren,
  )

interface AuthedRouteRouteChildren {
  AuthedDeviceRoute: typeof AuthedDeviceRoute
  AuthedSitesSiteIdRouteRoute: typeof AuthedSitesSiteIdRouteRouteWithChildren
  AuthedSettingsBillingRoute: typeof AuthedSettingsBillingRoute
  AuthedSitesIndexRoute: typeof AuthedSitesIndexRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedDeviceRoute: AuthedDeviceRoute,
  AuthedSitesSiteIdRouteRoute: AuthedSitesSiteIdRouteRouteWithChildren,
  AuthedSettingsBillingRoute: AuthedSettingsBillingRoute,
  AuthedSitesIndexRoute: AuthedSitesIndexRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  SelectOrgRoute: SelectOrgRoute,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
